import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_details",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_details"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = {
  id: "kt_ad_create_details",
  class: "collapse show"
}
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_10 = { class: "col-lg-4 fv-row" }
const _hoisted_11 = { class: "col-lg-2 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-4 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_16 = { class: "col-lg-2 col-form-label required fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-4 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row mb-6" }
const _hoisted_21 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_22 = { class: "required" }
const _hoisted_23 = { class: "col-lg-4 fv-row" }
const _hoisted_24 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_29 = { class: "col-lg-4 fv-row" }
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = {
  key: 0,
  class: "col-lg-2 col-form-label fw-bold fs-6"
}
const _hoisted_32 = { class: "required" }
const _hoisted_33 = {
  key: 1,
  class: "col-lg-4 fv-row"
}
const _hoisted_34 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = {
  key: 2,
  class: "col-lg-2 col-form-label fw-bold fs-6"
}
const _hoisted_39 = { class: "required" }
const _hoisted_40 = {
  key: 3,
  class: "col-lg-4 fv-row"
}
const _hoisted_41 = {
  disabled: "",
  selected: "",
  value: "0"
}
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "fv-plugins-message-container" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "row mb-6" }
const _hoisted_46 = {
  key: 0,
  class: "row"
}
const _hoisted_47 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_48 = { class: "col-lg-4 fv-row" }
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_52 = { class: "col-lg-4 fv-row" }
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = { class: "d-flex" }
const _hoisted_57 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "required" }
const _hoisted_59 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_60 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_61 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_62 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_63 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_64 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_65 = {
  key: 0,
  class: "row"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_67 = { class: "col-lg-4 fv-row" }
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = { class: "col-lg-2 col-form-label fw-bold fs-6 required" }
const _hoisted_72 = { class: "col-lg-4 fv-row" }
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-4 fv-row" }
const _hoisted_78 = { class: "fv-plugins-message-container" }
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { class: "row mb-6" }
const _hoisted_81 = { class: "d-flex" }
const _hoisted_82 = { class: "col-lg-2 col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "required" }
const _hoisted_84 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_85 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_86 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_87 = { class: "form-check-label user-select-none text-muted fs-7 p-2" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_90 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_91 = {
  type: "submit",
  id: "kt_ad_create_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_92 = { class: "indicator-label" }
const _hoisted_93 = { class: "indicator-progress" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_95 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_96 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_attachments",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_attachments"
}
const _hoisted_97 = { class: "card-title m-0" }
const _hoisted_98 = { class: "fw-bolder m-0" }
const _hoisted_99 = {
  id: "kt_ad_create_attachments",
  class: "collapse show"
}
const _hoisted_100 = { class: "card-body border-top p-9" }
const _hoisted_101 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6" }
const _hoisted_102 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_103 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_104 = { class: "fw-bold" }
const _hoisted_105 = { class: "fs-6 text-gray-600" }
const _hoisted_106 = { class: "row mb-6" }
const _hoisted_107 = { class: "row mb-12" }
const _hoisted_108 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_109 = { class: "col-lg-12" }
const _hoisted_110 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_111 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-6" }, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_create",
  multiple: ""
}, null, -1)
const _hoisted_114 = { class: "fv-plugins-message-container" }
const _hoisted_115 = { class: "fv-help-block" }
const _hoisted_116 = { class: "form-text" }
const _hoisted_117 = { class: "image-input-wrapper" }
const _hoisted_118 = { class: "thumbnail-grid" }
const _hoisted_119 = { class: "thumbnail-container" }
const _hoisted_120 = ["src"]
const _hoisted_121 = ["onClick"]
const _hoisted_122 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_123 = [
  _hoisted_122
]
const _hoisted_124 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_125 = { class: "indicator-label" }
const _hoisted_126 = { class: "indicator-progress" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_128 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_129 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_video_attachments",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_video_attachments"
}
const _hoisted_130 = { class: "card-title m-0" }
const _hoisted_131 = { class: "fw-bolder m-0" }
const _hoisted_132 = {
  id: "kt_ad_create_video_attachments",
  class: "collapse show"
}
const _hoisted_133 = { class: "card-body border-top p-9" }
const _hoisted_134 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6" }
const _hoisted_135 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_136 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_137 = { class: "fw-bold" }
const _hoisted_138 = { class: "fs-6 text-gray-600" }
const _hoisted_139 = { class: "row mb-6" }
const _hoisted_140 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_141 = { class: "col-lg-8" }
const _hoisted_142 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_143 = {
  class: "image-input image-input-wrapper",
  "data-kt-image-input": "true"
}
const _hoisted_144 = ["data-video", "data-sub-html"]
const _hoisted_145 = ["src"]
const _hoisted_146 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change image"
}
const _hoisted_147 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-7" }, null, -1)
const _hoisted_148 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_149 = ["data-video", "data-sub-html"]
const _hoisted_150 = ["src"]
const _hoisted_151 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_152 = ["disabled"]
const _hoisted_153 = { class: "indicator-label" }
const _hoisted_154 = { class: "indicator-progress" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_156 = {
  key: 3,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_157 = {
  class: "card-header border-0",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_ad_create_doc_attachments",
  "aria-expanded": "true",
  "aria-controls": "kt_ad_create_doc_attachments"
}
const _hoisted_158 = { class: "card-title m-0" }
const _hoisted_159 = { class: "fw-bolder m-0" }
const _hoisted_160 = {
  id: "kt_ad_create_doc_attachments",
  class: "collapse show"
}
const _hoisted_161 = { class: "card-body border-top p-9" }
const _hoisted_162 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed mb-9 p-6" }
const _hoisted_163 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_164 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_165 = { class: "fw-bold" }
const _hoisted_166 = { class: "fs-6 text-gray-600" }
const _hoisted_167 = { class: "row mb-6" }
const _hoisted_168 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_169 = { class: "col-lg-12" }
const _hoisted_170 = {
  key: 0,
  class: "col-lg-12 fv-row"
}
const _hoisted_171 = {
  class: "image-input image-input-wrapper",
  "data-kt-image-input": "true"
}
const _hoisted_172 = ["src"]
const _hoisted_173 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change Doc"
}
const _hoisted_174 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-7" }, null, -1)
const _hoisted_175 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_176 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-60px symbol-2by3 me-4" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "symbol-label contain-symbol",
    style: {"background-image":"url('/media/svg/files/pdf.svg'"}
  })
], -1)
const _hoisted_177 = { class: "d-flex flex-row-fluid flex-wrap align-items-center" }
const _hoisted_178 = { class: "flex-grow-1 me-2" }
const _hoisted_179 = ["onClick"]
const _hoisted_180 = { class: "text-muted fw-bold d-block pt-1" }
const _hoisted_181 = ["onClick"]
const _hoisted_182 = { class: "svg-icon-2 svg-icon-primary" }
const _hoisted_183 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_184 = ["disabled"]
const _hoisted_185 = { class: "indicator-label" }
const _hoisted_186 = { class: "indicator-progress" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_lightgallery = _resolveComponent("lightgallery")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('update', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('AdInfo')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitUpdate,
              "validation-schema": _ctx.adsSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge fs-7 fw-semibold px-3 py-2", 
                _ctx.ad?.business_account_info || _ctx.ad?.members?.ownerId
                  ? 'badge-light-primary'
                  : 'badge-light-success'
              ])
                    }, _toDisplayString(_ctx.ad?.business_account_info || _ctx.ad?.members?.ownerId
                  ? _ctx.translate('brokerAccount')
                  : _ctx.translate('individualAccount')), 3)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('users')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedUser,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedUser) = $event)),
                        requierd: true,
                        label: "phone",
                        trackBy: "phone",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.appUsers,
                        placeholder: _ctx.translate('selectUsers'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ]),
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('name')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "name",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('User Name'),
                        modelValue: 
                  _ctx.ad?.members?.name ||
                  _ctx.ad?.members?.first_name + _ctx.ad?.members.last_name
                ,
                        disabled: ""
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "name" })
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.ad.business_account_info || _ctx.ad.members.ownerId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('officeName')), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "officeName",
                            autocomplete: "off",
                            class: "form-control form-control-lg form-control-solid",
                            placeholder: _ctx.translate('officeName'),
                            modelValue: 
                  _ctx.ad?.business_account_info?.name ??
                  _ctx.ad?.members?.officeName ??
                  ''
                ,
                            disabled: ""
                          }, null, 8, ["placeholder", "modelValue"]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_ErrorMessage, { name: "name" })
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate('adType')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "adTypesId",
                        class: "form-select form-select-solid form-select-lg text-capitalize",
                        modelValue: _ctx.selectedAdTypesId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAdTypesId) = $event)),
                        disabled: "disabled"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.translate('selectAdType')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adTypes, (adType) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: adType.id,
                              value: adType.id
                            }, _toDisplayString(adType.titleAr), 9, _hoisted_25))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_ErrorMessage, { name: "adTypesId" })
                        ])
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_28, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedArea,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedArea) = $event)),
                        requierd: true,
                        label: "titleAr",
                        trackBy: "titleAr",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areas,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (
                _ctx.propertyTypesCategories && _ctx.propertyTypesCategories.length > 0
              )
                      ? (_openBlock(), _createElementBlock("label", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.translate('propertyCategory')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                _ctx.propertyTypesCategories && _ctx.propertyTypesCategories.length > 0
              )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "propertyCategoryId",
                            class: "form-select form-select-solid form-select-lg text-capitalize",
                            modelValue: _ctx.selectedPropertyCategoryId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedPropertyCategoryId) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.translate('selectPropertyCategories')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypesCategories, (propertyCategory) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: propertyCategory.id,
                                  value: propertyCategory.id
                                }, _toDisplayString(propertyCategory.titleAr), 9, _hoisted_35))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_ErrorMessage, { name: "selectedPropertyCategoryId" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.propertyTypes && _ctx.propertyTypes.length > 0)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.translate('propertyTypes')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.propertyTypes && _ctx.propertyTypes.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createVNode(_component_Field, {
                            as: "select",
                            name: "propertyTypeId",
                            class: "form-select form-select-solid form-select-lg text-capitalize",
                            modelValue: _ctx.selectedPropertyTypesId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPropertyTypesId) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.translate('selectPropertyTypes')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertyTypes, (propertyType) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: propertyType.id,
                                  value: propertyType.id
                                }, _toDisplayString(propertyType.titleAr), 9, _hoisted_42))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_ErrorMessage, { name: "propertyTypeId" })
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    (_ctx.selectedAdTypesId == 3 || _ctx.selectedAdTypesId == 4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("label", _hoisted_47, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.translate('numRooms')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_Field, {
                              type: "number",
                              min: "0",
                              name: "numRooms",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('numRooms'),
                              modelValue: _ctx.ad.numRooms,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ad.numRooms) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createVNode(_component_ErrorMessage, { name: "numRooms" })
                              ])
                            ])
                          ]),
                          _createElementVNode("label", _hoisted_51, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.translate('numBathrooms')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_Field, {
                              type: "number",
                              min: "0",
                              name: "numBathrooms",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('numBathrooms'),
                              modelValue: _ctx.ad.numBathrooms,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ad.numBathrooms) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createVNode(_component_ErrorMessage, { name: "numBathrooms" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("label", _hoisted_57, [
                        _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.translate('price')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_59, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.priceVal) = $event)),
                          type: "radio",
                          value: "0"
                        }, null, 512), [
                          [_vModelRadio, _ctx.priceVal]
                        ]),
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.translate('price')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_61, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.priceVal) = $event)),
                          type: "radio",
                          value: "-1"
                        }, null, 512), [
                          [_vModelRadio, _ctx.priceVal]
                        ]),
                        _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.translate('askSeller')), 1)
                      ]),
                      _createElementVNode("label", _hoisted_63, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.priceVal) = $event)),
                          type: "radio",
                          value: "-2"
                        }, null, 512), [
                          [_vModelRadio, _ctx.priceVal]
                        ]),
                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.translate('priceNotAvailable')), 1)
                      ])
                    ]),
                    (_ctx.priceVal >= 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_component_Field, {
                              type: "number",
                              min: "0",
                              name: "price",
                              autocomplete: "off",
                              class: "form-control form-control-lg form-control-solid",
                              placeholder: _ctx.translate('price'),
                              modelValue: _ctx.price,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.price) = $event))
                            }, null, 8, ["placeholder", "modelValue"]),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _createVNode(_component_ErrorMessage, { name: "price" })
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('size')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createVNode(_component_Field, {
                        type: "number",
                        min: "0",
                        name: "size",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('size'),
                        modelValue: _ctx.ad.size,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ad.size) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createVNode(_component_ErrorMessage, { name: "size" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.translate('adDetails')), 1),
                    _createElementVNode("div", _hoisted_77, [
                      _createVNode(_component_Field, {
                        as: "textarea",
                        type: "text",
                        name: "adDetails",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('adDetailsLang'),
                        modelValue: _ctx.ad.additionalInfo,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ad.additionalInfo) = $event))
                      }, null, 8, ["placeholder", "modelValue"]),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _createVNode(_component_ErrorMessage, { name: "adDetails" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("label", _hoisted_82, [
                          _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.translate('adOptions')), 1)
                        ]),
                        _createElementVNode("label", _hoisted_84, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isSpecial) = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.isSpecial]
                          ]),
                          _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.translate('featuredAd')), 1)
                        ]),
                        _createElementVNode("label", _hoisted_86, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isHighQuality) = $event)),
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.isHighQuality]
                          ]),
                          _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.translate('displayOnHomepage')), 1)
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_88,
                  _hoisted_89
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", _hoisted_91, [
                    _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_93, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_94
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("h3", _hoisted_98, _toDisplayString(_ctx.translate('adImagesAttachments')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("span", _hoisted_102, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.translate('savingAdAttachmentNote')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.translate('images')), 1),
                  _createElementVNode("div", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", {
                        class: "image-input-wrapper w-125px h-125px",
                        style: _normalizeStyle(`background-image: url(${_ctx.thumbnail})`)
                      }, null, 4),
                      _createElementVNode("label", _hoisted_111, [
                        _hoisted_112,
                        _createVNode(_component_Field, {
                          type: "file",
                          name: "images",
                          accept: ".png, .jpg, .jpeg",
                          multiple: true,
                          "max-files": 10,
                          modelValue: _ctx.imagesInput,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.imagesInput) = $event)),
                          onChange: _ctx.previewImages
                        }, null, 8, ["modelValue", "onChange"]),
                        _hoisted_113
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createVNode(_component_ErrorMessage, { name: "images" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.translate('allowedFileTypes')), 1),
                    _createElementVNode("div", _hoisted_117, [
                      _createElementVNode("div", _hoisted_118, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thumbnailImages, (image, index) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_119, [
                            _createElementVNode("img", {
                              src: image['name'] ? image['name'] : image,
                              class: "thumbnail-image img-ads"
                            }, null, 8, _hoisted_120),
                            (_ctx.can('remove', 'ads'))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "remove-button",
                                  onClick: ($event: any) => (_ctx.removeImage(image['id'], index))
                                }, _hoisted_123, 8, _hoisted_121))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_ad_create_attachments_images_submit",
                ref: "submitImagesButton",
                class: "btn btn-primary",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.onSubmitImages && _ctx.onSubmitImages(...args)))
              }, [
                _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_126, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_127
                ])
              ], 512)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("h3", _hoisted_131, _toDisplayString(_ctx.translate('adVideoAttachments')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_132, [
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, [
                _createElementVNode("span", _hoisted_135, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.translate('savingAdAttachmentNote')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_139, [
                _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.translate('video')) + ": ", 1),
                _createElementVNode("div", _hoisted_141, [
                  (!_ctx.videoInput)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                        _createVNode(_component_Field, {
                          type: "file",
                          accept: "video/*",
                          name: "",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('adVideo'),
                          modelValue: _ctx.videoInput,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.videoInput) = $event)),
                          onChange: _ctx.previewVideo
                        }, null, 8, ["placeholder", "modelValue", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_143, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_lightgallery, {
                        onInit: _ctx.onInit,
                        onBeforeSlide: _ctx.updateSlides,
                        "data-poster": "",
                        settings: { download: false, speed: 500, plugins: _ctx.plugins }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            "data-video": `{"source": [{"src":"${_ctx.guideVideo}", "type":"video/mp4"}], "attributes": {"dynamic": false, "controls": true}}`,
                            "data-sub-html": `<h4> video - <a href='https://alhisba.com/' >alhisba.com </a></h4> <p> - video- </a></p>`
                          }, [
                            _createElementVNode("video", {
                              class: "image-input-wrapper d-inline-block w-auto h-200px overflow-hidden",
                              role: "button",
                              src: _ctx.guideVideo
                            }, null, 8, _hoisted_145)
                          ], 8, _hoisted_144)
                        ]),
                        _: 1
                      }, 8, ["onInit", "onBeforeSlide", "settings"])
                    ]),
                    _createElementVNode("label", _hoisted_146, [
                      _hoisted_147,
                      _createVNode(_component_Field, {
                        type: "file",
                        accept: "video/*",
                        name: "",
                        autocomplete: "off",
                        placeholder: _ctx.translate('adVideo'),
                        filename: "guideVideo",
                        modelValue: _ctx.videoInput,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.videoInput) = $event)),
                        onChange: _ctx.previewVideo
                      }, null, 8, ["placeholder", "modelValue", "onChange"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.videoInput]
                  ])
                ])
              ]),
              (
            _ctx.ad.thumbnail && _ctx.ad.thumbnail.video && _ctx.ad.thumbnail.video.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                    _createVNode(_component_lightgallery, {
                      settings: {
              zoom: false,
              download: false,
              speed: 500,
              plugins: _ctx.plugins,
            },
                      onInit: _ctx.onInit,
                      onBeforeSlide: _ctx.onBeforeSlide
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          class: "gallery-item",
                          "data-video": `{"source": [{"src":"${_ctx.ad.thumbnail.video[0].name}", "type":"video/mp4"}], "attributes": {"preload": false, "controls": true}}`,
                          "data-poster": "",
                          "data-sub-html": `<h4>Ads video - <a href='https://alhisba.com/' >alhisba.com </a></h4> <p> - video- </a></p>`
                        }, [
                          _createElementVNode("img", {
                            class: "img-responsive fixed-size border border-5 rounded",
                            src: _ctx.ad.thumbnail.video[0].thumbnail
                          }, null, 8, _hoisted_150)
                        ], 8, _hoisted_149)
                      ]),
                      _: 1
                    }, 8, ["settings", "onInit", "onBeforeSlide"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_151, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_ad_create_attachments_submit",
                ref: "submitVideoButton",
                class: "btn btn-primary",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onSubmitVideo && _ctx.onSubmitVideo(...args))),
                disabled: !_ctx.videoInput
              }, [
                _createElementVNode("span", _hoisted_153, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_154, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_155
                ])
              ], 8, _hoisted_152)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('update', 'ads'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
          _createElementVNode("div", _hoisted_157, [
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("h3", _hoisted_159, _toDisplayString(_ctx.translate('adDocAttachments')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("div", _hoisted_161, [
              _createElementVNode("div", _hoisted_162, [
                _createElementVNode("span", _hoisted_163, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen045.svg" })
                ]),
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("div", _hoisted_165, [
                    _createElementVNode("div", _hoisted_166, _toDisplayString(_ctx.translate('savingAdAttachmentNote')), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_167, [
                _createElementVNode("label", _hoisted_168, _toDisplayString(_ctx.translate('adDocAttachments')) + ": ", 1),
                _createElementVNode("div", _hoisted_169, [
                  (!_ctx.docInput)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                        _createVNode(_component_Field, {
                          type: "file",
                          accept: ".pdf,application/pdf",
                          name: "",
                          autocomplete: "off",
                          class: "form-control form-control-lg form-control-solid",
                          placeholder: _ctx.translate('adDocAttachments'),
                          modelValue: _ctx.docInput,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.docInput) = $event)),
                          onChange: _ctx.previewDoc
                        }, null, 8, ["placeholder", "modelValue", "onChange"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_171, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_lightgallery, {
                        onInit: _ctx.onInitDoc,
                        onBeforeSlide: _ctx.updateSlidesDoc,
                        "data-poster": "",
                        settings: { download: false, speed: 500, plugins: _ctx.plugins }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("iframe", {
                            class: "image-input-wrapper d-inline-block w-auto h-400px overflow-hidden",
                            src: _ctx.adsPdf,
                            type: "application/pdf"
                          }, null, 8, _hoisted_172)
                        ]),
                        _: 1
                      }, 8, ["onInit", "onBeforeSlide", "settings"])
                    ]),
                    _createElementVNode("label", _hoisted_173, [
                      _hoisted_174,
                      _createVNode(_component_Field, {
                        type: "file",
                        accept: ".pdf,application/pdf",
                        name: "",
                        autocomplete: "off",
                        placeholder: _ctx.translate('adDoc'),
                        filename: "adsPdf",
                        modelValue: _ctx.docInput,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.docInput) = $event)),
                        onChange: _ctx.previewDoc
                      }, null, 8, ["placeholder", "modelValue", "onChange"])
                    ])
                  ], 512), [
                    [_vShow, _ctx.docInput]
                  ])
                ]),
                (
              _ctx.ad.thumbnail &&
              _ctx.ad.thumbnail.document &&
              _ctx.ad.thumbnail.document.length > 0
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ad.thumbnail.document, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `propertyImage-${index}`,
                          class: _normalizeClass([{
                  'mb-7': _ctx.ad.thumbnail.document.length - 1 !== index,
                }, "d-flex align-items-sm-center"])
                        }, [
                          _hoisted_176,
                          _createElementVNode("div", _hoisted_177, [
                            _createElementVNode("div", _hoisted_178, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "text-gray-800 fw-bolder text-hover-primary fs-6 text-capitalize",
                                onClick: _withModifiers(($event: any) => (_ctx.downloadAttachment(item)), ["prevent"])
                              }, _toDisplayString(_ctx.getAttachmentName(item, index)), 9, _hoisted_179),
                              _createElementVNode("span", _hoisted_180, _toDisplayString(item.mime), 1)
                            ]),
                            _createElementVNode("a", {
                              href: "#",
                              class: "btn btn-icon btn-light btn-sm border-0 me-3",
                              onClick: _withModifiers(($event: any) => (_ctx.downloadAttachment(item)), ["prevent"])
                            }, [
                              _createElementVNode("span", _hoisted_182, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr065.svg" })
                              ])
                            ], 8, _hoisted_181)
                          ])
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_183, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-white btn-active-light-primary me-2",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, _toDisplayString(_ctx.translate('discard')), 1),
              _createElementVNode("button", {
                id: "kt_ad_create_attachments_submit",
                ref: "submitDocButton",
                class: "btn btn-primary",
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onSubmitDoc && _ctx.onSubmitDoc(...args))),
                disabled: !_ctx.docInput
              }, [
                _createElementVNode("span", _hoisted_185, _toDisplayString(_ctx.translate('saveChanges')), 1),
                _createElementVNode("span", _hoisted_186, [
                  _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                  _hoisted_187
                ])
              ], 8, _hoisted_184)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}